webpackJsonp([64],{

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

var _emailjsCom = __webpack_require__(1027);

var emailjs = _interopRequireWildcard(_emailjsCom);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(558);

var _Button2 = _interopRequireDefault(_Button);

var _ButtonLink = __webpack_require__(593);

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

var _InputFloatingLabel = __webpack_require__(568);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

var _Modal = __webpack_require__(563);

var _Modal2 = _interopRequireDefault(_Modal);

var _RDGateway = __webpack_require__(561);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

__webpack_require__(942);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'phone', 'erp', 'needs'];

var RequestContactv2 = function (_Component) {
    _inherits(RequestContactv2, _Component);

    function RequestContactv2(props) {
        _classCallCheck(this, RequestContactv2);

        var _this = _possibleConstructorReturn(this, (RequestContactv2.__proto__ || Object.getPrototypeOf(RequestContactv2)).call(this, props));

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);
        return _this;
    }

    _createClass(RequestContactv2, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                showDemoForm: false,
                name: '',
                email: '',
                phone: '',
                erp: '',
                needs: '',
                typingTimeout: 0
            };

            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });

            return initialObject;
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true,
                showDemoForm: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false,
                showDemoForm: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var stateKey = void 0;
            var targetId = e.target.id;
            var value = e.target.value;

            if (targetId.includes('-field')) {
                stateKey = targetId.substring(0, targetId.indexOf('-field'));
            } else if (targetId === 'email') {
                stateKey = 'email';
            } else if (targetId === 'telephone') {
                stateKey = 'phone';
            } else {
                stateKey = targetId;
            }

            if (stateKey === 'phone') {
                value = this.phoneMask(value);
            }

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, stateKey, value), _defineProperty(_setState, stateKey + 'Error', false), _defineProperty(_setState, stateKey + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (stateKey === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};

            var regexPhone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            FIELDS.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'phone':
                        {
                            newState[campo + 'Error'] = !regexPhone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'phoneMask',
        value: function phoneMask(value) {
            var cleanPhone = value ? value.replace(/\D/g, "") : '',
                numberLength = cleanPhone.length;

            if (numberLength > 10) {
                cleanPhone = cleanPhone.slice(0, 7) + '-' + cleanPhone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanPhone = cleanPhone.slice(0, 6) + '-' + cleanPhone.slice(6);
            }

            if (numberLength > 2) {
                cleanPhone = cleanPhone.slice(0, 2) + ') ' + cleanPhone.slice(2);
            }

            if (numberLength > 0) {
                cleanPhone = '(' + cleanPhone.slice(0);
            }

            return cleanPhone;
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            var _this4 = this;

            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicitou-contato-parceiro-marketplace',
                    'cf_tipo_de_conversao': 'Solicitou contato de um parceiro no Marketplace',
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.phone,
                    cf_erp_utilizado: this.state.erp,
                    cf_descricao_da_necessidade: this.state.needs || '',
                    cf_carteira_clientes_canais: this.props.portifolioOwner || '',
                    'cf_codigo_do_parceiro_meus_pedidos': this.props.partnerId,
                    'cf_nome_do_parceiro_canais1': this.props.partnerName

                };

                emailjs.send('amazon_ses', 'template_marketplace', {
                    partnerEmail: this.props.partnerEmail,
                    contactName: this.state.name,
                    contactEmail: this.state.email,
                    contactPhone: this.state.phone,
                    contactErp: this.state.erp,
                    contactNeeds: this.state.needs || ''
                }, 'user_FFC9ya35Vf3Im0waOm5He');

                this.rdGateway.sendToRDStation(data);

                this.setState({
                    showDemoForm: false
                });

                setTimeout(function () {
                    _this4.setState({
                        showDemoModal: false,
                        showDemoForm: true
                    });
                }, 3000);
            }
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this5 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this5.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('new-form-wrapper', this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement(
                        'h4',
                        { className: 'form-heading' },
                        'Preencha o formul\xE1rio abaixo e solicite um contato agora mesmo'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this5.submitForm(e);
                            } },
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name-field', value: this.state.name, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            }, error: this.state.nameError, autoFocus: true, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.phone, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            }, error: this.state.phoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'erp-field', value: this.state.erp, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            }, error: this.state.erpError, placeholder: 'Qual ERP usa atualmente?' }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'needs-field' },
                            'Descreva sua necessidade:'
                        ),
                        _react2.default.createElement('textarea', { id: 'needs-field', defaultValue: this.state.needs, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            } }),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', radius: this.props.radius, className: this.props.className },
                                'SOLICITAR CONTATO'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container-form-confirm', !this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement('img', { className: 'success-icon', src: '/images/success.png', alt: 'Solicita\xE7\xE3o enviada com sucesso!' }),
                    _react2.default.createElement(
                        'p',
                        { className: 'paragraph' },
                        'Sua solicita\xE7\xE3o foi enviada com sucesso!'
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    _ButtonLink2.default,
                    _extends({
                        href: '.',
                        className: (0, _classnames2.default)(this.props.className, this.props.color === '#FFFFFF' ? '#494a5e' : this.props.color && 'colored'),
                        onClick: function onClick(e) {
                            return _this6.openDemoModal(e);
                        },
                        title: 'Solicite o contato de um dos nossos especialistas.',
                        radius: this.props.radius,
                        size: this.props.size,
                        style: this.props.style
                    }, this.props.color && { style: { color: this.props.color } }),
                    this.props.children || 'peça uma demonstração'
                ),
                this.state.showDemoModal && this.getDemoModal()
            );
        }
    }]);

    return RequestContactv2;
}(_react.Component);

RequestContactv2.propTypes = {
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    radius: _propTypes2.default.string
};
RequestContactv2.defaultProps = {
    radius: 'half-rounded'
};
exports.default = RequestContactv2;

/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailJSResponseStatus = exports.sendForm = exports.send = exports.init = void 0;
var EmailJSResponseStatus_1 = __webpack_require__(1028);
Object.defineProperty(exports, "EmailJSResponseStatus", { enumerable: true, get: function () { return EmailJSResponseStatus_1.EmailJSResponseStatus; } });
var UI_1 = __webpack_require__(1029);
var _userID = null;
var _origin = 'https://api.emailjs.com';
function sendPost(url, data, headers) {
    if (headers === void 0) { headers = {}; }
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.addEventListener('load', function (event) {
            var responseStatus = new EmailJSResponseStatus_1.EmailJSResponseStatus(event.target);
            if (responseStatus.status === 200 || responseStatus.text === 'OK') {
                resolve(responseStatus);
            }
            else {
                reject(responseStatus);
            }
        });
        xhr.addEventListener('error', function (event) {
            reject(new EmailJSResponseStatus_1.EmailJSResponseStatus(event.target));
        });
        xhr.open('POST', url, true);
        for (var key in headers) {
            xhr.setRequestHeader(key, headers[key]);
        }
        xhr.send(data);
    });
}
function appendGoogleCaptcha(templatePrams) {
    var element = document && document.getElementById('g-recaptcha-response');
    if (element && element.value) {
        templatePrams['g-recaptcha-response'] = element.value;
    }
    element = null;
    return templatePrams;
}
function fixIdSelector(selector) {
    if (selector[0] !== '#' && selector[0] !== '.') {
        return '#' + selector;
    }
    return selector;
}
/**
 * Initiation
 * @param {string} userID - set the EmailJS user ID
 * @param {string} origin - set the EmailJS origin
 */
function init(userID, origin) {
    _userID = userID;
    _origin = origin || 'https://api.emailjs.com';
}
exports.init = init;
/**
 * Send a template to the specific EmailJS service
 * @param {string} serviceID - the EmailJS service ID
 * @param {string} templateID - the EmailJS template ID
 * @param {Object} templatePrams - the template params, what will be set to the EmailJS template
 * @param {string} userID - the EmailJS user ID
 * @returns {Promise<EmailJSResponseStatus>}
 */
function send(serviceID, templateID, templatePrams, userID) {
    var params = {
        lib_version: '2.6.4',
        user_id: userID || _userID,
        service_id: serviceID,
        template_id: templateID,
        template_params: appendGoogleCaptcha(templatePrams)
    };
    return sendPost(_origin + '/api/v1.0/email/send', JSON.stringify(params), {
        'Content-type': 'application/json'
    });
}
exports.send = send;
/**
 * Send a form the specific EmailJS service
 * @param {string} serviceID - the EmailJS service ID
 * @param {string} templateID - the EmailJS template ID
 * @param {string | HTMLFormElement} form - the form element or selector
 * @param {string} userID - the EmailJS user ID
 * @returns {Promise<EmailJSResponseStatus>}
 */
function sendForm(serviceID, templateID, form, userID) {
    if (typeof form === 'string') {
        form = document.querySelector(fixIdSelector(form));
    }
    if (!form || form.nodeName !== 'FORM') {
        throw 'Expected the HTML form element or the style selector of form';
    }
    UI_1.UI.progressState(form);
    var formData = new FormData(form);
    formData.append('lib_version', '2.6.4');
    formData.append('service_id', serviceID);
    formData.append('template_id', templateID);
    formData.append('user_id', userID || _userID);
    return sendPost(_origin + '/api/v1.0/email/send-form', formData)
        .then(function (response) {
        UI_1.UI.successState(form);
        return response;
    }, function (error) {
        UI_1.UI.errorState(form);
        return Promise.reject(error);
    });
}
exports.sendForm = sendForm;
exports.default = {
    init: init,
    send: send,
    sendForm: sendForm
};


/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailJSResponseStatus = void 0;
var EmailJSResponseStatus = /** @class */ (function () {
    function EmailJSResponseStatus(httpResponse) {
        this.status = httpResponse.status;
        this.text = httpResponse.responseText;
    }
    return EmailJSResponseStatus;
}());
exports.EmailJSResponseStatus = EmailJSResponseStatus;


/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UI = void 0;
var UI = /** @class */ (function () {
    function UI() {
    }
    UI.clearAll = function (form) {
        form.classList.remove(this.PROGRESS);
        form.classList.remove(this.DONE);
        form.classList.remove(this.ERROR);
    };
    UI.progressState = function (form) {
        this.clearAll(form);
        form.classList.add(this.PROGRESS);
    };
    UI.successState = function (form) {
        form.classList.remove(this.PROGRESS);
        form.classList.add(this.DONE);
    };
    UI.errorState = function (form) {
        form.classList.remove(this.PROGRESS);
        form.classList.add(this.ERROR);
    };
    UI.PROGRESS = 'emailjs-sending';
    UI.DONE = 'emailjs-success';
    UI.ERROR = 'emailjs-error';
    return UI;
}());
exports.UI = UI;


/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

var _Heading = __webpack_require__(598);

var _Heading2 = _interopRequireDefault(_Heading);

var _Heading3 = __webpack_require__(597);

var _Heading4 = _interopRequireDefault(_Heading3);

var _Paragraph = __webpack_require__(564);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

var _RequestContactv = __webpack_require__(1026);

var _RequestContactv2 = _interopRequireDefault(_RequestContactv);

var _NewMenu = __webpack_require__(580);

var _NewMenu2 = _interopRequireDefault(_NewMenu);

var _NewFooterV = __webpack_require__(575);

var _NewFooterV2 = _interopRequireDefault(_NewFooterV);

__webpack_require__(1030);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
    var headData = _ref.headData,
        company = _ref.company;
    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            _reactStatic.Head,
            null,
            _react2.default.createElement(
                'title',
                null,
                headData.pageTitle
            ),
            _react2.default.createElement('meta', { property: 'og:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'twitter:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { name: 'twitter:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { name: 'twitter:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { property: 'og:url', content: headData.ogUrl }),
            _react2.default.createElement('link', { rel: 'canonical', href: headData.ogUrl })
        ),
        _react2.default.createElement(MarketplacePartner, { company: company })
    );
});


var PARTNERS_THAT_SET_UP_IN_MERCOS = [];

var MarketplacePartner = function (_Component) {
    _inherits(MarketplacePartner, _Component);

    function MarketplacePartner(props) {
        _classCallCheck(this, MarketplacePartner);

        var _this = _possibleConstructorReturn(this, (MarketplacePartner.__proto__ || Object.getPrototypeOf(MarketplacePartner)).call(this, props));

        _this.state = {
            isSegmentsOpen: false,
            isServicesOpen: false
        };
        return _this;
    }

    _createClass(MarketplacePartner, [{
        key: 'toggleList',
        value: function toggleList(label) {
            this.setState(_defineProperty({}, 'is' + label + 'Open', !this.state['is' + label + 'Open']));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var companyData = this.props.company.data,
                id = companyData.id,
                title = companyData.title,
                ranking = companyData.ranking,
                logo = companyData.logo,
                color = companyData.color,
                email = companyData.email,
                url = (companyData.url && companyData.url.indexOf('//') > -1 ? companyData.url : 'http://' + companyData.url) + '?utm_source=mercos&utm_medium=marketplace&utm_campaign=mercos-marketplace-indication',
                shortDescription = companyData.short_description,
                description = companyData.description,
                indication = companyData.indication,
                address = companyData.address,
                category = companyData.category,
                regions = companyData.regions,
                segments = companyData.segments,
                services = companyData.services,
                portifolioOwner = companyData.portifolio_owner,
                slug = companyData.slug;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-partner-details-container' },
                    _react2.default.createElement(_NewMenu2.default, { mutableMenu: true, pixelsToShowMenuWhite: 50 }),
                    _react2.default.createElement('div', { className: 'top-purple-bg' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'partner-details-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'container' },
                            _react2.default.createElement(
                                'div',
                                { className: 'navigation-breadcrumbs' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'breadcrumbs desktop-only' },
                                    _react2.default.createElement(
                                        'a',
                                        { href: '/integracao-erp', className: 'button-txt' },
                                        'ERPs Integrados'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'navigation-breadcrumbs-separator' },
                                        '/'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        title
                                    )
                                ),
                                _react2.default.createElement(
                                    'a',
                                    { className: 'back-button', href: '/integracao-erp' },
                                    '\u2039 voltar'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                _extends({ className: 'partner-head-container' }, color && { style: { backgroundColor: color } }),
                                _react2.default.createElement('div', { className: 'partner-logo-container', style: { backgroundImage: 'url(\'' + logo + '\')' } }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'cta-container' },
                                    _react2.default.createElement(
                                        _RequestContactv2.default,
                                        {
                                            className: 'btn-partner-contact',
                                            color: color,
                                            portifolioOwner: portifolioOwner,
                                            partnerEmail: email,
                                            partnerId: id,
                                            partnerName: title },
                                        'FALAR COM PARCEIRO'
                                    ),
                                    PARTNERS_THAT_SET_UP_IN_MERCOS.includes(slug) && _react2.default.createElement(
                                        'a',
                                        {
                                            className: 'new-button button-secondary-black',
                                            target: '_blank',
                                            title: 'Configure no mercos',
                                            href: 'https://app.mercos.com/nova_integracao/?erp=' + slug },
                                        'CONFIGURAR NO MERCOS'
                                    ),
                                    url && _react2.default.createElement(
                                        'a',
                                        {
                                            className: 'button-txt marketplace-partner-url',
                                            target: '_blank',
                                            title: 'Configure no mercos',
                                            href: url },
                                        'site do parceiro \u203A'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'partner-content-container' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'content-container top-container' },
                                    _react2.default.createElement(
                                        _Heading2.default,
                                        { className: 'partner-name' },
                                        title
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'left-container' },
                                    description && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container title-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Descri\xE7\xE3o do neg\xF3cio:'
                                        ),
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            description
                                        )
                                    ),
                                    segments && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container partner-segments-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Segmento que atende:'
                                        ),
                                        segments.map(function (segment, index) {
                                            var isHidden = !this.state.isSegmentsOpen && index > 4;

                                            return _react2.default.createElement(
                                                _Paragraph2.default,
                                                { className: (0, _classnames2.default)('list-item', isHidden && 'hide'), key: 'partner-segment-' + (index + 1) },
                                                '\u2022 ' + segment
                                            );
                                        }, this),
                                        segments.length > 5 && _react2.default.createElement(
                                            _Paragraph2.default,
                                            { className: (0, _classnames2.default)('toggle-button', this.state.isSegmentsOpen && 'open'), onClick: function onClick() {
                                                    return _this2.toggleList('Segments');
                                                } },
                                            this.state.isSegmentsOpen ? 'Esconder' : 'Ver mais'
                                        )
                                    ),
                                    services && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container partner-services-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Servi\xE7os:'
                                        ),
                                        services.map(function (service, index) {
                                            var isHidden = !this.state.isServicesOpen && index > 4;

                                            return _react2.default.createElement(
                                                _Paragraph2.default,
                                                { className: (0, _classnames2.default)('list-item', isHidden && 'hide'), key: 'partner-service-' + (index + 1) },
                                                '\u2022 ' + service
                                            );
                                        }, this),
                                        services.length > 5 && _react2.default.createElement(
                                            _Paragraph2.default,
                                            { className: (0, _classnames2.default)('toggle-button', this.state.isServicesOpen && 'open'), onClick: function onClick() {
                                                    return _this2.toggleList('Services');
                                                } },
                                            this.state.isServicesOpen ? 'Esconder' : 'Ver mais'
                                        )
                                    ),
                                    indication && _react2.default.createElement(
                                        'div',
                                        { className: (0, _classnames2.default)('content-container partner-indication-container', color && 'custom-color') },
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            indication
                                        ),
                                        _react2.default.createElement('div', { className: 'indication-background', style: { 'backgroundColor': color } })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'right-container' },
                                    category && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container category-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Categoria:'
                                        ),
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            category
                                        )
                                    ),
                                    regions && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container regions-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Regi\xE3o que atende:'
                                        ),
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            regions.join(', ')
                                        )
                                    ),
                                    address && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container address-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Sede da empresa:'
                                        ),
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            address
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(_NewFooterV2.default, null)
                )
            );
        }
    }]);

    return MarketplacePartner;
}(_react.Component);

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(554);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Constants for Mercos site numbers
// Centralized place to manage all the client numbers and revenue figures

var SITE_CONSTANTS = exports.SITE_CONSTANTS = {
  // Client numbers (updated to 9 mil)
  CLIENTS_COUNT: '9 mil',
  CLIENTS_COUNT_WITH_PLUS: '+9 mil',
  CLIENTS_COUNT_DETAILED: '9.000',
  CLIENTS_COUNT_WITH_COMMA: '9,0 mil',

  // Revenue (updated to 80 bi)
  ANNUAL_REVENUE: 'R$ 80 BI',
  ANNUAL_REVENUE_LOWERCASE: 'R$ 80 bi',

  // Other numbers that might be used
  USERS_COUNT: '+52 mil',
  ERPS_INTEGRATED: '+250',
  ANNUAL_ORDERS: '+ 14 MI'

  // Helper functions to get formatted numbers
};var getClientsCount = exports.getClientsCount = function getClientsCount() {
  var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

  switch (format) {
    case 'plus':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS;
    case 'detailed':
      return SITE_CONSTANTS.CLIENTS_COUNT_DETAILED;
    case 'comma':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA;
    default:
      return SITE_CONSTANTS.CLIENTS_COUNT;
  }
};

var getRevenue = exports.getRevenue = function getRevenue() {
  var lowercase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return lowercase ? SITE_CONSTANTS.ANNUAL_REVENUE_LOWERCASE : SITE_CONSTANTS.ANNUAL_REVENUE;
};

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(38);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsCookie = __webpack_require__(554);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RDGateway = function () {
  function RDGateway() {
    _classCallCheck(this, RDGateway);
  }

  _createClass(RDGateway, [{
    key: "sendToRDStation",
    value: function sendToRDStation(data, redirectLink) {
      var _this = this;

      var dataCookies = {
        cf_origem: _jsCookie2.default.get("mutm_source") || "",
        cf_midia: _jsCookie2.default.get("mutm_medium") || "",
        cf_campanha: _jsCookie2.default.get("mutm_campaign") || "",
        cf_utm_term: _jsCookie2.default.get("mutm_term") || "",
        cf_utm_content: _jsCookie2.default.get("mutm_content") || "",
        cf_fbclid: _jsCookie2.default.get("mfbclid") || "",
        cf_glcid: _jsCookie2.default.get("mgclid") || "",
        cf_wbraid: _jsCookie2.default.get("mwbraid") || "",
        cf_gbraid: _jsCookie2.default.get("mgbraid") || "",
        website: "Mercos",
        cf_page_url: window.location.origin + window.location.pathname,
        cf_page_title: document.title,
        cf_ga4_client_id: _jsCookie2.default.get("_ga") || "",
        cf_ga4_muser_id: _jsCookie2.default.get("MUserID") || ""
      };

      this.hashEmail(data.email).then(function (hashedEmail) {
        var enrichedData = _extends({}, dataCookies, data, { cf_email_hash: hashedEmail });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.entries(enrichedData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = _slicedToArray(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            enrichedData[key] = String(value);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.sendDataLayer(enrichedData);

        Promise.all([_this.sendToRD(enrichedData), _this.sendToHubspot(enrichedData)]).then(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              responseRD = _ref4[0],
              responseHubspot = _ref4[1];

          if (responseRD || responseHubspot) {
            if (redirectLink) {
              window.location = redirectLink;
            }
          } else {
            //alert("Ooops! Tivemos um pequeno problema no recebimento do formulário. Por favor, tente novamente.")
          }
        });
      });
    }
  }, {
    key: "sendDataLayer",
    value: function sendDataLayer(enrichedData) {
      try {
        window.dataLayer = window.dataLayer || [];
        var dataLayerObject = {
          event: "event_track",
          event_category: "form_submit",
          event_action: enrichedData.event_action || "",
          event_label: (enrichedData.event_label || "").replace(/-/g, "_"),
          MUserId: "",
          emailHash: enrichedData.cf_email_hash || "",
          email: enrichedData.email || "",
          codigo_parceiro: enrichedData.cf_codigo_do_parceiro_meus_pedidos || "",
          event_cnpj: enrichedData.cf_cnpj ? "sim" : "nao"
        };

        if (this.getCompanyType(enrichedData)) {
          dataLayerObject.event_companyType = this.getCompanyType(enrichedData);
        }

        dataLayer.push(dataLayerObject);
        return true;
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: "gaexpDataSplit",
    value: function gaexpDataSplit(data) {
      try {
        var arr = data.split(".");
        var value = "";
        return value.concat(arr[2], ".", arr[4]);
      } catch (error) {
        return "";
      }
    }
  }, {
    key: "hashEmail",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(email) {
        var encoder, emailBytes, hashBytes, hashArray, hashHex;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                encoder = new TextEncoder();
                emailBytes = encoder.encode(email.toLowerCase());
                _context.next = 5;
                return crypto.subtle.digest("SHA-256", emailBytes);

              case 5:
                hashBytes = _context.sent;
                hashArray = Array.from(new Uint8Array(hashBytes));
                hashHex = hashArray.map(function (bytes) {
                  return bytes.toString(16).padStart(2, "0");
                }).join("");
                return _context.abrupt("return", hashHex.slice(0, 36));

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", "");

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function hashEmail(_x) {
        return _ref5.apply(this, arguments);
      }

      return hashEmail;
    }()
  }, {
    key: "getCompanyType",
    value: function getCompanyType(type) {
      if (type && type.cf_atividade_da_empresa) {
        if (type.cf_atividade_da_empresa === "Representante comercial" || type.cf_atividade_da_empresa === "Representação Comercial") {
          return "representacao_comercial";
        } else if (type.cf_atividade_da_empresa === "Distribuição") {
          return "distribuicao";
        } else if (type.cf_atividade_da_empresa === "Indústria") {
          return "industria";
        } else if (type.cf_atividade_da_empresa === "Outra" || type.cf_atividade_da_empresa === "Outro") {
          return "outro";
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }, {
    key: "sendToRD",
    value: function sendToRD(enrichedData) {
      var data = JSON.stringify({
        event_type: "CONVERSION",
        event_family: "CDP",
        payload: enrichedData
      });

      return fetch("https://api.rd.services/platform/conversions?api_key=abSCjrNCSWZvTKmxPEuGiTMxdFFtMlJbyBqX", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer"
        },
        body: data
      }).then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      }).catch(function (error) {
        console.log(error);
        return false;
      });
    }
  }, {
    key: "sendToHubspot",
    value: function sendToHubspot(enrichedData) {
      var _hsq = window._hsq = window._hsq || [];
      _hsq.push(["identify", {
        conversion_identifier: enrichedData.conversion_identifier || "",
        company: enrichedData.company_name || "",
        nome: enrichedData.name || "",
        email: enrichedData.email || "",
        telefone: enrichedData.personal_phone || "",
        time: enrichedData.cf_time || "",
        atividade_da_empresa: enrichedData["cf_atividade_da_empresa"] || "",
        numero_de_vendedores: enrichedData["cf_numero_de_vendedores"] || ""
      }]);

      var hubspotForm = {
        fields: [{
          objectTypeId: "0-1",
          name: "email",
          value: enrichedData.email || ""
        }, {
          objectTypeId: "0-1",
          name: "firstname",
          value: enrichedData.name || ""
        }, {
          objectTypeId: "0-1",
          name: "identificador",
          value: enrichedData.conversion_identifier || ""
        }, {
          objectTypeId: "0-1",
          name: "company",
          value: enrichedData.company_name || ""
        }, {
          objectTypeId: "0-1",
          name: "phone",
          value: enrichedData.personal_phone || ""
        }, {
          objectTypeId: "0-1",
          name: "time",
          value: enrichedData.cf_time || ""
        }, {
          objectTypeId: "0-1",
          name: "atividade_da_empresa",
          value: enrichedData["cf_atividade_da_empresa"] || ""
        }, {
          objectTypeId: "0-1",
          name: "numero_de_vendedores",
          value: enrichedData["cf_numero_de_vendedores"] || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_origem",
          value: enrichedData["cf_origem"] || ""
        }, {
          objectTypeId: "0-1",
          name: "midia",
          value: enrichedData["cf_midia"] || ""
        }, {
          objectTypeId: "0-1",
          name: "campanha",
          value: enrichedData["cf_campanha"] || ""
        }, {
          objectTypeId: "0-1",
          name: "termo",
          value: enrichedData["cf_utm_term"] || ""
        }, {
          objectTypeId: "0-1",
          name: "conteudo",
          value: enrichedData["cf_utm_content"] || ""
        }, {
          objectTypeId: "0-1",
          name: "fbclid",
          value: enrichedData["cf_fbclid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "gclid",
          value: enrichedData["cf_glcid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_wbraid",
          value: enrichedData["cf_wbraid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "gbraid",
          value: enrichedData["cf_gbraid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "tipo_de_conversao",
          value: enrichedData["cf_tipo_de_conversao"] || ""
        }, {
          objectTypeId: "0-1",
          name: "codigo_do_parceiro_meus_pedidos",
          value: enrichedData["cf_codigo_do_parceiro_meus_pedidos"] || ""
        }, {
          objectTypeId: "0-1",
          name: "city",
          value: enrichedData["city"] || ""
        }, {
          objectTypeId: "0-1",
          name: "erp_utilizado",
          value: enrichedData["cf_erp_utilizado"] || ""
        }, {
          objectTypeId: "0-1",
          name: "descricao_da_necessidade",
          value: enrichedData["cf_descricao_da_necessidade"] || ""
        }, {
          objectTypeId: "0-1",
          name: "carteira_clientes_canais",
          value: enrichedData["cf_carteira_clientes_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "nome_do_parceiro__canais1_",
          value: enrichedData["cf_nome_do_parceiro_canais1"] || ""
        }, {
          objectTypeId: "0-1",
          name: "clientes_ativos__canais_",
          value: enrichedData["cf_clientes_ativos_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "ramo_de_atuacao__canais_",
          value: enrichedData["cf_ramo_de_atuacao_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "percentual_perfil_ind_dist__canais_",
          value: enrichedData["cf_percentual_perfil_ind_dist_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "observacoes",
          value: enrichedData["cf_observacoes"] || ""
        }, {
          objectTypeId: "0-1",
          name: "unidade_de_negocio_salesforce",
          value: enrichedData["cf_unidade_de_negocio_salesforce"] || ""
        }, {
          objectTypeId: "0-1",
          name: "site",
          value: enrichedData["website"] || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_isoptimizetest",
          value: enrichedData["cf_isoptimizetest"] || ""
        }, {
          objectTypeId: "0-1",
          name: "empresa",
          value: enrichedData.company_name || ""
        }, {
          objectTypeId: "0-1",
          name: "telefone",
          value: enrichedData.personal_phone || ""
        }, {
          objectTypeId: "0-1",
          name: "email_hash",
          value: enrichedData.cf_email_hash || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_cnpj",
          value: enrichedData.cf_cnpj || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_honeypot",
          value: enrichedData.cf_honeypot || ""
        }],
        context: {
          pageUri: window.location.origin + window.location.pathname,
          pageName: document.title
        }
      };

      return fetch("https://api.hsforms.com/submissions/v3/integration/submit/21596284/632b7e2d-915b-4384-86eb-678c7bb78e4a", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(hubspotForm)
      }).then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      }).catch(function (error) {
        console.log(error);
        return false;
      });
    }
  }]);

  return RDGateway;
}();

exports.default = RDGateway;

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(569);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(571);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(562);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paragraph = function Paragraph(_ref) {
    var center = _ref.center,
        children = _ref.children,
        className = _ref.className,
        gray = _ref.gray,
        italic = _ref.italic,
        left = _ref.left,
        _onClick = _ref.onClick,
        small = _ref.small,
        white = _ref.white;
    return _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)('paragraph', className, center && 'text-center', gray && 'heading-gray', italic && 'italic', left && 'text-left', small && 'small', white && 'heading-white'),
            onClick: function onClick(e) {
                return _onClick ? _onClick(e) : null;
            } },
        children
    );
};

exports.default = Paragraph;

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement(
        'div',
        { className: 'floating-label-wrapper' },
        _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
            'aria-label': ariaLabel,
            autoFocus: autoFocus,
            id: id,
            maxLength: maxLength,
            onChange: onChange,
            type: type,
            value: value,
            name: name || id,
            required: true
        }),
        _react2.default.createElement(
            'span',
            { className: 'floating-label' },
            placeholder
        )
    );
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(570);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(576);

var _Utm = __webpack_require__(555);

var _constants = __webpack_require__(560);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var footerSections = [{
        title: 'Mercos',
        links: [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }, { name: 'Integrações', url: '/integracao-erp/' }, { name: 'Carreira', url: 'https://mercos.gupy.io/' }, { name: 'Sobre Nós', url: '/sobre/' }]
    }, {
        title: 'Soluções',
        links: [{ name: 'Força de vendas', url: '/forca-vendas/' }, { name: 'E-commerce B2B', url: '/e-commerce-b2b/', highlight: true }, { name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' }, { name: 'Mercos Pay', url: '/mercos-pay', highlight: true }, { name: 'Videochamada', url: '/videochamada/' }]
    }, {
        title: 'Segmentos',
        links: [{ name: 'Indústrias', url: '/industrias/' }, { name: 'Distribuidoras', url: '/distribuidoras/' }, { name: 'Representantes', url: '/representantes-comerciais/' }]
    }, {
        title: 'Conteúdo',
        links: [{ name: 'Blog', url: 'https://blog.mercos.com/' }, { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI' }, { name: _react2.default.createElement(
                _react.Fragment,
                null,
                'E-commerce B2B: ',
                _react2.default.createElement('br', null),
                ' O que \xE9?'
            ), url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank' }]
    }, {
        title: 'Suporte',
        links: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb' }, {
            name: '(47) 3481.8050',
            custom: true,
            content: _react2.default.createElement(
                'div',
                { className: 'support-info' },
                _react2.default.createElement(
                    'div',
                    { className: 'support-phone' },
                    '(47) 3481.8050'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'support-hours' },
                    'Atendimento de Segunda',
                    _react2.default.createElement('br', null),
                    'a Quinta das 9h \xE0s 17h.',
                    _react2.default.createElement('br', null),
                    'Sexta das 9h30 \xE0s 17h.'
                )
            )
        }]
    }, {
        title: 'Transparência',
        links: [{ name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' }, { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' }, { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank' }, { name: 'Relatório da igualdade salarial', url: '/documentos/relatorio-igualdade-salarial-mercos.pdf' }]
    }];

    var renderLink = function renderLink(link) {
        if (link.custom) {
            return link.content;
        }

        return _react2.default.createElement(
            'a',
            {
                className: 'footer-link ' + (link.highlight ? 'highlight' : ''),
                href: link.redirect ? null : link.url,
                onClick: link.redirect ? function () {
                    return (0, _Utm.redirectWithCookies)(link.url);
                } : null,
                target: link.target || null,
                rel: link.target === '_blank' ? 'noopener noreferrer' : null
            },
            link.name
        );
    };

    var socialLinks = [{ name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' }, { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' }, { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' }, { name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' }, { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }];

    return _react2.default.createElement(
        'footer',
        { className: 'mercos-footer' },
        _react2.default.createElement(
            'div',
            { className: 'footer-content' },
            _react2.default.createElement(
                'div',
                { className: 'footer-main' },
                footerSections.map(function (section, index) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'footer-section', key: index },
                        _react2.default.createElement(
                            'p',
                            { className: 'section-title' },
                            section.title
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section-links' },
                            section.links.map(function (link, linkIndex) {
                                return _react2.default.createElement(
                                    'div',
                                    { className: 'link-item', key: linkIndex },
                                    renderLink(link)
                                );
                            })
                        )
                    );
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'footer-app-download' },
                _react2.default.createElement(
                    'div',
                    { className: 'download-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'download-title' },
                        'Baixe o aplicativo e teste gr\xE1tis'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Junte-se a mais de ',
                        _constants.SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA,
                        ' clientes que automatizaram e aumentaram suas vendas com a Mercos.'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'app-buttons' },
                    _react2.default.createElement(
                        'a',
                        { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                        _react2.default.createElement('img', { src: '/images/site/social/google-play.png', alt: 'Dispon\xEDvel no Google Play' })
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                        _react2.default.createElement('img', { src: '/images/site/social/app-store.png', alt: 'Baixar na App Store' })
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'footer-bottom' },
                _react2.default.createElement('div', { className: 'footer-hr-line' }),
                _react2.default.createElement(
                    'div',
                    { className: 'footer-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'logo-container' },
                        _react2.default.createElement(
                            'a',
                            { href: '/', className: 'mercos-logo' },
                            _react2.default.createElement('img', { src: '/images/mercos-nuvini.svg', alt: 'Mercos - uma empresa nuvini' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'company-info' },
                        'Simplest Software Ltda CNPJ: 12.496.510/0001-80 Insc. Estadual: ISENTO Av. Rolf Wiest, 277 (7\xBA andar) Bom Retiro - Joinville/SC | CEP: 89223-005'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'social-links' },
                        socialLinks.map(function (social, index) {
                            return _react2.default.createElement(
                                'a',
                                {
                                    key: index,
                                    href: social.url,
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    className: 'social-link',
                                    'aria-label': social.name
                                },
                                _react2.default.createElement('img', { src: social.icon, alt: 'Mercos no ' + social.name })
                            );
                        }),
                        _react2.default.createElement(
                            'span',
                            { className: 'feito-com-amor' },
                            'Feito com \uD83D\uDC9C'
                        )
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(578);

var _Utm = __webpack_require__(555);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewMenuV2 = function NewMenuV2() {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeMenu = _useState2[0],
      setActiveMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mobileMenuOpen = _useState4[0],
      setMobileMenuOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileSubMenuIndex = _useState6[0],
      setMobileSubMenuIndex = _useState6[1];

  var menuData = [{
    label: 'Soluções',
    items: [{
      title: 'Força de vendas',
      description: '+25 indicadores e +30 relatórios para gerenciar sua equipe',
      icon: '/images/site/icons/graph.svg',
      link: '/forca-vendas/'
    }, {
      title: 'E-commerce B2B',
      description: 'Venda 24h por dia com a loja online de empresas para empresas',
      icon: '/images/site/icons/cart.svg',
      link: '/e-commerce-b2b'
    }, {
      type: 'separator',
      label: 'Outras soluções'
    }, {
      title: 'Pedidos com IA',
      description: 'Transforme áudio, texto, imagem ou planilha em pedidos com a IA',
      icon: '/images/site/recursos/sparkle.svg',
      link: '/recursos/sistema-pedidos-com-ia',
      badge: _react2.default.createElement(
        'div',
        { className: 'new-badge' },
        'NOVO'
      )
    }, {
      title: 'Mercos Pay',
      description: 'Receba pagamentos por pix, boleto e cartões de crédito',
      icon: '/images/site/icons/card.svg',
      link: '/mercos-pay'
    }, {
      title: 'Videochamada',
      description: 'Venda por vídeo com experiência de visita presencial dentro do e-commerce B2B',
      icon: '/images/site/icons/videocall.svg',
      link: '/videochamada'
    }]
  }, {
    label: 'Segmentos',
    items: [{
      title: 'Indústrias',
      description: 'Automatize vendas, conecte canais e escale seu negócio com inteligência',
      icon: '/images/site/icons/industry.svg',
      link: '/sistema-para-industria/'
    }, {
      title: 'Distribuidoras',
      description: 'Gerencie clientes e pedidos, vendas automatizadas e integração total',
      icon: '/images/site/icons/distributor.svg',
      link: '/sistema-distribuidora/'
    }, {
      title: 'Representantes',
      description: 'Crie e gerencie políticas comerciais para cada cliente e representada',
      icon: '/images/site/icons/representatives.svg',
      link: '/sistema-representante/'
    }]
  }, {
    label: 'Planos e Preços',
    items: [{
      title: _react2.default.createElement(
        _react.Fragment,
        null,
        'Planos para ',
        _react2.default.createElement(
          'b',
          null,
          'Ind\xFAstrias e distribuidoras'
        )
      ),
      description: '',
      icon: '/images/site/icons/industry.svg',
      link: '/planos-e-precos/industrias-e-distribuidoras/'
    }, {
      title: _react2.default.createElement(
        _react.Fragment,
        null,
        'Planos para ',
        _react2.default.createElement('br', null),
        ' ',
        _react2.default.createElement(
          'b',
          null,
          'Representantes'
        )
      ),
      description: '',
      icon: '/images/site/icons/representatives.svg',
      link: '/planos-e-precos/representantes/'
    }]
  }, {
    label: 'Integrações',
    items: [{
      title: 'ERPs integrados',
      description: '+ 250 ERPs parceiros integrados ao Forças de vendas e E-commerce B2B',
      icon: '/images/site/icons/mapping.svg',
      link: '/integracao-erp'
    }, {
      title: 'Seja Parceiro',
      description: 'Seja um Mpartner e leve seu negócio ao próximo nível',
      icon: '/images/site/icons/people.svg',
      link: '/parceiros'
    }]
  }];

  var MobileCTA = function MobileCTA() {
    return _react2.default.createElement(
      'div',
      { className: 'nmv2-mobile-actions' },
      _react2.default.createElement(
        'button',
        {
          className: 'nmv2-mobile-cta-button',
          onClick: function onClick() {
            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
          }
        },
        'comece gr\xE1tis'
      ),
      _react2.default.createElement(
        'div',
        {
          className: 'nmv2-mobile-login-link',
          onClick: function onClick() {
            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
          }
        },
        'entrar no Mercos ',
        _react2.default.createElement('img', { src: '/images/arrow-vector.svg', alt: 'arrow' })
      )
    );
  };

  var handleMouseEnter = function handleMouseEnter(index) {
    return setActiveMenu(index);
  };
  var handleMouseLeave = function handleMouseLeave() {
    return setActiveMenu(null);
  };

  var toggleMobileMenu = function toggleMobileMenu() {
    setMobileMenuOpen(!mobileMenuOpen);
    if (mobileMenuOpen) {
      setMobileSubMenuIndex(null);
    }
  };

  var toggleMobileSubMenu = function toggleMobileSubMenu(index) {
    setMobileSubMenuIndex(mobileSubMenuIndex === index ? null : index);
  };

  var goBackToMainMenu = function goBackToMainMenu() {
    setMobileSubMenuIndex(null);
  };

  (0, _react.useEffect)(function () {
    if (mobileMenuOpen) {
      document.body.classList.add('mobile-menu-is-open');
    } else {
      document.body.classList.remove('mobile-menu-is-open');
    }
    return function () {
      document.body.classList.remove('mobile-menu-is-open');
    };
  }, [mobileMenuOpen]);

  return _react2.default.createElement(
    'nav',
    { className: 'newmenuv2' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'menu-logo' },
        _react2.default.createElement(
          'a',
          { href: '/' },
          _react2.default.createElement('img', {
            src: '/images/site/logo-mercos-colored.svg',
            alt: 'Mercos Logo',
            className: 'nmv2-logo'
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'menu-list' },
        _react2.default.createElement(
          'ul',
          { className: 'nmv2-menu-list' },
          menuData.map(function (menuItem, idx) {
            return _react2.default.createElement(
              'li',
              {
                key: idx,
                className: 'nmv2-menu-item ' + (menuItem.className || ''),
                onMouseEnter: function onMouseEnter() {
                  return handleMouseEnter(idx);
                },
                onMouseLeave: handleMouseLeave
              },
              _react2.default.createElement(
                'button',
                { className: 'nmv2-menu-button' },
                menuItem.label
              ),
              _react2.default.createElement(
                'div',
                { className: 'nmv2-submenu ' + (activeMenu === idx ? 'active' : '') },
                _react2.default.createElement('div', { className: 'submenu-arrow-up' }),
                _react2.default.createElement(
                  'ul',
                  null,
                  menuItem.items.map(function (item, subIdx) {
                    if (item.type === 'separator') {
                      return _react2.default.createElement(
                        'li',
                        { key: subIdx, className: 'nmv2-submenu-separator' },
                        item.label
                      );
                    }
                    return _react2.default.createElement(
                      'li',
                      { key: subIdx, className: 'nmv2-submenu-item' },
                      _react2.default.createElement(
                        'a',
                        { href: item.link },
                        _react2.default.createElement('img', {
                          src: item.icon,
                          alt: item.title + ' icon',
                          className: 'nmv2-submenu-icon'
                        }),
                        _react2.default.createElement(
                          'div',
                          { className: 'nmv2-submenu-text' },
                          _react2.default.createElement(
                            'div',
                            { className: 'item-title' },
                            typeof item.title === 'string' ? _react2.default.createElement(
                              'strong',
                              null,
                              item.title
                            ) : item.title,
                            item.badge && item.badge
                          ),
                          _react2.default.createElement(
                            'p',
                            null,
                            item.description
                          )
                        )
                      )
                    );
                  })
                )
              )
            );
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'menu-signin' },
        _react2.default.createElement(
          'button',
          {
            className: 'nmv2-cta-button',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'nmv2-login-link',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Entrar ',
          _react2.default.createElement('img', { src: '/images/arrow-vector.svg', alt: 'arrow' })
        )
      ),
      _react2.default.createElement(
        'button',
        {
          className: 'nmv2-hamburger',
          onClick: toggleMobileMenu,
          'aria-label': 'Open mobile menu'
        },
        mobileMenuOpen ? _react2.default.createElement('img', { src: '/images/site/icons/close-menu.svg', alt: 'Fechar' }) : _react2.default.createElement('img', { src: '/images/site/icons/hamburger.svg', alt: 'Abrir' })
      ),
      mobileMenuOpen && _react2.default.createElement(
        'div',
        { className: 'nmv2-mobile-menu' },
        mobileSubMenuIndex === null ? _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'ul',
            { className: 'nmv2-mobile-menu-list' },
            menuData.map(function (menuItem, idx) {
              return _react2.default.createElement(
                'li',
                { key: idx, className: 'nmv2-mobile-menu-item' },
                _react2.default.createElement(
                  'button',
                  {
                    className: 'nmv2-mobile-menu-button',
                    onClick: function onClick() {
                      return toggleMobileSubMenu(idx);
                    }
                  },
                  menuItem.label,
                  _react2.default.createElement('span', { className: 'nmv2-mobile-arrow' })
                )
              );
            })
          ),
          _react2.default.createElement(MobileCTA, null)
        ) : _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'nmv2-mobile-submenu' },
            _react2.default.createElement(
              'div',
              { className: 'nmv2-mobile-submenu-header' },
              _react2.default.createElement(
                'button',
                { className: 'nmv2-mobile-back-button', onClick: goBackToMainMenu },
                _react2.default.createElement('span', { className: 'nmv2-mobile-back-arrow' }),
                menuData[mobileSubMenuIndex].label
              )
            ),
            _react2.default.createElement(
              'ul',
              { className: 'nmv2-mobile-submenu-list' },
              menuData[mobileSubMenuIndex].items.map(function (item, subIdx) {
                if (item.type === 'separator') {
                  return _react2.default.createElement(
                    'li',
                    { key: subIdx, className: 'nmv2-mobile-submenu-separator' },
                    item.label
                  );
                }
                return _react2.default.createElement(
                  'li',
                  { key: subIdx, className: 'nmv2-mobile-submenu-item' },
                  _react2.default.createElement(
                    'a',
                    { href: item.link },
                    _react2.default.createElement('img', {
                      src: item.icon,
                      alt: item.title + ' icon',
                      className: 'nmv2-mobile-submenu-icon'
                    }),
                    _react2.default.createElement(
                      'div',
                      { className: 'nmv2-mobile-submenu-text' },
                      _react2.default.createElement(
                        'div',
                        { className: 'mobile-item-title' },
                        typeof item.title === 'string' ? _react2.default.createElement(
                          'strong',
                          null,
                          item.title
                        ) : item.title,
                        item.badge && item.badge
                      ),
                      _react2.default.createElement(
                        'p',
                        null,
                        item.description
                      )
                    )
                  )
                );
              })
            ),
            _react2.default.createElement(MobileCTA, null)
          )
        )
      )
    )
  );
};

exports.default = NewMenuV2;

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NewMenuv = __webpack_require__(577);

var _NewMenuv2 = _interopRequireDefault(_NewMenuv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NewMenuv2.default;

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLink = function ButtonLink(_ref) {
    var children = _ref.children,
        color = _ref.color,
        model = _ref.model,
        size = _ref.size,
        radius = _ref.radius,
        className = _ref.className,
        _ref$href = _ref.href,
        href = _ref$href === undefined ? '/' : _ref$href,
        target = _ref.target,
        rel = _ref.rel,
        title = _ref.title,
        onClick = _ref.onClick,
        style = _ref.style,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        shake = _ref.shake;
    return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('button', model, size, radius, className, color, shake && 'shake'),
            href: href,
            target: target,
            title: title,
            onClick: onClick,
            style: style,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            rel: rel ? rel : target === '_blank' ? 'noopener noreferrer' : '' },
        children
    );
};

ButtonLink.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.any,
    color: _propTypes2.default.string,
    href: _propTypes2.default.string,
    model: _propTypes2.default.oneOf(['outline', 'secondary', 'success', 'alert', 'warning']),
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded']),
    size: _propTypes2.default.string,
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    title: _propTypes2.default.string
};

exports.default = ButtonLink;

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(562);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading5 = function Heading5(_ref) {
    var children = _ref.children,
        white = _ref.white,
        left = _ref.left,
        className = _ref.className,
        green = _ref.green,
        gray = _ref.gray,
        center = _ref.center,
        onClick = _ref.onClick;
    return _react2.default.createElement(
        'h5',
        { className: (0, _classnames2.default)(className, 'heading5', left && 'text-left', white ? 'heading-white' : '', green ? 'heading-green' : '', gray ? 'heading-5-gray' : '', center ? 'text-center' : ''), onClick: onClick },
        children
    );
};

exports.default = Heading5;

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(553);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(562);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading1 = function Heading1(_ref) {
    var children = _ref.children,
        white = _ref.white,
        center = _ref.center,
        className = _ref.className,
        left = _ref.left,
        style = _ref.style,
        purple = _ref.purple,
        black = _ref.black;
    return _react2.default.createElement(
        'h1',
        { style: style,
            className: (0, _classnames2.default)('heading1', className, white && 'heading-white', center && 'text-center', left && 'text-left', purple && 'heading-purple', black && 'heading-black') },
        children
    );
};

exports.default = Heading1;

/***/ }),

/***/ 942:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/marketplace/MarketplacePartnerv2.jsx.41c60cdb.js